<body class="ltr main-body leftmenu">
  <form autocomplete="off" novalidate>
    <!-- Main Content-->
    <div class="main-content side-content pt-0 ml-0">
      <div class="main-container container-fluid">
        <div class="inner-body">


          <div class="row row-sm add-form" *ngIf="list == true ">
            <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamSubjectForm ">
              <div class="col-lg-12 col-md-12">

                <div class="card custom-card">
                  <div class="card-body">

                    <div class="row">
                      <div class="col-md-8">
                        <div class=" d-flex align-items-center pl-3">
                          <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                          <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                               {{'header.exam-subject.table.ExamSubjectRecord'| translate}}
                              </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                              {{'header.exam-subject.table.ExamSubjectMapping'| translate}}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="PrintIF" class="col-md-4 prpl">
                        <button type="button"
                            class="btn btn-primary btn-icon-text  mt-1 mr-3 floatright"
                            (click)="print()">
                            <span style="display: contents; align-items: center;">
                              <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                              {{'header.exam-subject.table.Print'| translate}}
                          </span>
                        </button>
                    </div>
                    </div>
                    <hr>
                    <div class="row clearfix">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width mt-2">
                              <mat-label>
                                {{'header.exam-subject.table.Course'
                                |
                                translate
                                }}
                              </mat-label>
                              <mat-select #select51 panelClass="custom-select-panel" class="colorblack"
                                formControlName="course" [displayMember]="'CoName'">
                                <mat-select-filter *ngIf="select51.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CoName'" [array]="CourseList"
                                  (filteredReturn)="filteredListCourse =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCode "
                                  (click)="getList(item)">
                                  {{item.CoCode}} - {{item.CoName}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['course'].touched && ExamSubjectForm.controls['course'].errors?.required">
                                {{'header.exam-subject.table.Mandatory'| translate}}
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['course'].touched && ExamSubjectForm.controls['course'].errors?.pattern">
                                {{'header.exam-subject.table.Invalid'| translate}}
                              </mat-error>
                            </mat-form-field>

                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width mt-2">
                              <mat-label>
                                {{'header.exam-subject.table.ExamName'
                                |
                                translate
                                }}
                              </mat-label>
                              <!-- <input matInput formControlName="CoGPAm" placeholder="CoGPAm"required> -->
                              <mat-select [disabled]="disableExam" #select52 class="colorblack" formControlName="exam">
                                <mat-select-filter *ngIf="select52.focused" [placeholder]="'Filter'"
                                  [displayMember]="'EmName'" [array]="examList"
                                  (filteredReturn)="filteredListExam =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListExam" [value]="item.EmCode"
                                  (click)="get(item)">
                                  {{item.EmCode}} - {{item.EmName}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['exam'].touched && ExamSubjectForm.controls['exam'].errors?.required">
                                 {{'header.exam-subject.table.Mandatory'| translate}}
                              </mat-error>
                              <mat-error class="margin_tp"
                                *ngIf="ExamSubjectForm.controls['exam'].touched && ExamSubjectForm.controls['exam'].errors?.pattern">
                                {{'header.exam-subject.table.Invalid'| translate}}
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <!-- this is was disabled is now being enabled -->
                      <div class="col-sm-4" *ngIf="Branch">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width mt-2">
                              <mat-label>
                                {{'header.exam-subject.table.ExamBranch'| translate}}
                              </mat-label>

                              <mat-select #select53 class="colorblack" formControlName="strId">
                                <mat-select-filter *ngIf="select53.focused" [placeholder]="'Filter'"
                                  [displayMember]="'item.StrId'" [array]="BranchList"
                                  (filteredReturn)="filteredListBranch =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListBranch" [value]="item.StrId"
                                  (click)="getStr(item)">
                                  {{item.StrName}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width mt-2" >
                              <mat-label>
                                New
                              </mat-label>
                             
                              <mat-select  #select54 [disabled]="disableNew" class="colorblack" formControlName="new">
                                <mat-select-filter *ngIf="select54.focused" [placeholder]="'Filter'"
                                  [displayMember]="'name'" [array]="selectDropdown"
                                  (filteredReturn)="filterlist =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filterlist" [value]="item.id" 
                            
                                (click)="openSubjectExamPopUP(item.id,'d','new')">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                         
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-sm-4">
                        <div class="form-group">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width mt-2">
                              <mat-label>
                                {{'header.exam-subject.table.New'| translate}}
                              </mat-label>

                              <mat-select #select54 [disabled]="disableNew" class="colorblack" formControlName="new">
                                <mat-select-filter *ngIf="select54.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="DrpList"
                                  (filteredReturn)="filteredListOfDrp =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListOfDrp" [value]="item.id"
                                  (click)="openSubjectExamPopUP(item.CdCode,'d','new')">
                                  {{item.CdDesc}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                          </div>
                        </div>
                      </div> -->

                      <div class="col-sm-12">
                        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                          <!-- This is the tree node template for leaf nodes -->
                          <!-- There is inline padding applied to this node using styles.
                            This padding value depends on the mat-icon-button width. -->
                          <mat-tree-node class="borderMain" *matTreeNodeDef="let node" matTreeNodeToggle>

                            <!-- <mat-tree-node class="" *matTreeNodeDef="let node" matTreeNodeToggle> -->
                            <div class="setBorder"></div>
                           
                            <a title="Edit" class="btn-floating m1"><i aria-hidden="true"> {{node.EsType}}</i></a>

                            <a class="m1">{{node.EsCode}} - {{node.EsName}}</a>
                            <a class="btn-floating m1" (mouseover)="showTooltip(node.EsType, node,'edit')" (mouseout)="hideTooltip()">
                              <i class="fa fa-eye eye"></i></a>
                            <app-tooltip *ngIf="isTooltipVisible && currentlyHoveredNode === node" [data]="tooltipData"></app-tooltip>
                            <a title="Edit"  class="btn-floating m1"><i
                                (click)="openSubjectExamPopUP(node.EsType, node,'edit')" class="fa fa-edit"
                                aria-hidden="true"></i></a>
                            <a *ngIf="!node.children.length && subjectDelete" title="Delete" class="btn-floating m1">
                              <i *ngIf="!node.children.length"
                                (click)="openSubjectExamPopUP(node.EsType, node,'delete')" class="fas fa-trash"
                                aria-hidden="true"></i></a>
                            
                          </mat-tree-node>
                          <!-- This is the tree node template for expandable nodes -->
                          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                            <!-- <div class="mat-tree-node"> -->
                            <div class="mat-tree-node borderMain">
                              <div class="setBorder"></div>
                              <a title="Edit" class="btn-floating m1"><i aria-hidden="true"> {{node.EsType}}</i></a>
                              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.EsName">
                                <mat-icon class="mat-icon-rtl-mirror">
                                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}} </mat-icon>
                              </button>
                              {{node.EsCode}} - {{node.EsName}}
                              <a class="btn-floating m1" (mouseover)="showTooltip(node.EsType, node,'edit')" (mouseout)="hideTooltip()">
                                <i class="fa fa-eye eye"></i></a>
                              <app-tooltip *ngIf="isTooltipVisible && currentlyHoveredNode === node" [data]="tooltipData"></app-tooltip>
                              <!-- <button class="btn btn-sm btn-primary  mrginbtn" (click)="openSubjectExamPopUP(node.type)" > Edit</button> -->
                              <a title="Edit" class="btn-floating m1"><i
                                  (click)="openSubjectExamPopUP(node.EsType, node,'edit')" class="fa fa-edit"
                                  aria-hidden="true"></i></a>
                              <a *ngIf="!node.children.length" title="Delete" class="btn-floating m1">
                                <i *ngIf="!node.children.length"
                                  (click)="openSubjectExamPopUP(node.EsType, node,'delete')" class="fas fa-trash"
                                  aria-hidden="true">

                                </i></a>
                            </div>
                            <!-- There is inline padding applied to this div using styles.
                                  This padding value depends on the mat-icon-button width.  -->
                            <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group"
                              class="borderMain">
                              <ng-container matTreeNodeOutlet></ng-container>
                            </div>
                          </mat-nested-tree-node>
                        </mat-tree>
                      </div>
                      <div class="col-sm-12 align-right">
                        <button type="button"
                        class="btn size btn-primary btn-icon-text floatright mr-3 mt-1"
                          *ngIf="editButton" (click)="validate()">Validate Subjects
                        </button>

                        <button type="button"
                          class="  btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                          *ngIf="deleteButton">
                          {{'header.exam-subject.table.Delete'
                          |
                          translate
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </form>
</body>